// This is a custom JavaScript file for related-products.liquid custommized 'You May Also Like' Section - EdLandis.Dev 

function hideRelatedProductsHeadingIfNoGridContent() {
  const grid = document.querySelector('ul.grid.product-grid');
  const heading = document.querySelector('h2.related-products__heading');
  const relatedProductsSection = document.querySelector('product-recommendations.related-products');
    if (grid && relatedProductsSection) {
        if (grid.children.length === 0) {
            relatedProductsSection.style.display = 'none';
            heading.style.display = 'none';
        }
    }
}

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(hideRelatedProductsHeadingIfNoGridContent, 1500);
});